var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('AppLoader'):_vm._e()],1),_c('portal-target',{attrs:{"name":"replacePrefilledModal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }